import React from 'react';
import { Dialog } from '@headlessui/react';
import { ExitIcon } from '../../modules/Icons';
import { LicenseSelectionDialogProps } from '../../types/components/shared/LicenseSelectionDialogTypes';

const LicenseSelectionAssistDialog: React.FC<LicenseSelectionDialogProps> = (
  props: LicenseSelectionDialogProps
) => {
  const { dialogIsOpen, setDialogIsOpen } = props;

  return (
    <>
      <Dialog
        open={dialogIsOpen === true}
        onClose={() => {
          setDialogIsOpen(false);
        }}
        className="relative z-[51]"
        cy-test-id="licenseSelectionAssistDialogue">
        {/* Back drop */}
        <div className="fixed inset-0 bg-black/60">
          {/* full-screen scrollable container */}
          <div className="fixed inset-0 w-screen overflow-y-auto">
            {/* Container to center the panel */}
            <div className="flex min-h-full items-center justify-center p-2">
              <Dialog.Panel>
                <div className="unlock-modal bg-a-dark-gray shadow-lg drop-shadow-lg rounded-[10px] pt-10 px-4 lg:px-12 pb-12 text-white w-full">
                  <ExitIcon
                    cy-test-id="close-button"
                    className="absolute cursor-pointer w-[16px] h-[16px] lg:w-[24px] lg:h-[24px] top-5 right-5 lg:top-4 lg:right-4 z-50"
                    onClick={() => setDialogIsOpen(false)}
                  />
                  <div className="product-page text-white">
                    <Dialog.Title className="eurostile uppercase text-[20px] lg:text-[28px] font-bold tracking-wide leading-9">
                      Which License Do I need?
                    </Dialog.Title>
                    <p className="inter text-[12px] lg:text-[16px] text-gray-500 mt-4 w-full xl:w-[700px]">
                      All our licenses are royalty-free and are perpetual. Once you purchase, you can use our products
                      in an unlimited number of projects, forever! Learn about each license below to stay compliant
                      with our End-User License Agreement.
                    </p>
                    <h2 className="inter text-[18px] lg:text-[21px] font-bold text-a-blue mt-5 lg:mt-10">
                      Individual
                    </h2>
                    <p className="inter text-[12px] lg:text-[16px] text-gray-500 mt-1 w-full xl:w-[700px]">
                      This license is for a single person making below $200K USD in annual revenue, such as a
                      hobbyist, student, or freelancer. This is a fully commercial license, but it is granted
                      only to an individual, never a company. Meaning, the license is bound to the one person
                      purchasing and using the assets, not to a corporate entity.
                    </p>
                    <h2 className="inter text-[18px] lg:text-[21px] font-bold text-a-blue mt-5 lg:mt-10">
                      Startup
                    </h2>
                    <p className="inter text-[12px] lg:text-[16px] text-gray-500 mt-1 w-full xl:w-[700px]">
                      This license is for teams and studios making below $3 Million USD per year in revenue or
                      funding. This license covers all artists within your organization throughout all your
                      locations.
                    </p>
                    <h2 className="inter text-[18px] lg:text-[21px] font-bold text-a-blue mt-5 lg:mt-10">
                      Enterprise
                    </h2>
                    <p className="inter text-[12px] lg:text-[16px] text-gray-500 mt-1 w-full xl:w-[700px]">
                      The mandatory license for teams and studios making at least $3 Million USD per year in
                      revenue or funding. This license covers all artists within your organization throughout
                      all your locations or subsidiaries.
                    </p>
                    <p className="inter text-[12px] lg:text-[16px] text-gray-500 mt-5 lg:mt-10 w-full xl:w-[700px]">
                      Follow the link to read our full{' '}
                      <a href="/license" className="text-a-blue">
                        License Agreement
                      </a>
                      . Have the wrong license? You can
                      upgrade your plan to the correct license on our <a href="/pricing" className="text-a-blue">Pricing page</a>.
                    </p>
                  </div>
                </div>
              </Dialog.Panel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default LicenseSelectionAssistDialog;
